export default "__VITE_ASSET__f65b219f__"